import React from "react";
import { RemovePng } from "../../assets";
import "./AcInputText.css";

const AcInputText = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  label,
  maxLength,
  disabled,
  error,
  onkeypress,
  id,
  defaultValue,
  onBlur,
  style,
  required,
  min,
  max,
  step,
}) => {
  return (
    <div className="ac-inputText-input-wrapper">
      <label className="ac-inputText-label" htmlFor={label}>
        {label}
      </label>
      <div className="ac-inputText-input-container">
        <input
          className="ac-inputText-input"
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onkeypress={onkeypress}
          id={id}
          defaultValue={defaultValue}
          onBlur={onBlur}
          style={style}
          required={required}
          min={min}
          max={max}
          step={step}
        />
      </div>
      {error ? (
        <div className="ac-inputText-error-container">
          <img
            className="inputText-img"
            style={{ verticalAlign: "middle" }}
            src={RemovePng}
            alt=""
          />
          <span>{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default AcInputText;
